"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _MuiAccordionSummary = _interopRequireDefault(require("./components/MuiAccordionSummary/MuiAccordionSummary"));

var _MuiAccordionDetails = _interopRequireDefault(require("./components/MuiAccordionDetails/MuiAccordionDetails"));

var MuiAccordion = function MuiAccordion(_ref) {
  var rootClass = _ref.rootClass,
      accordionDetails = _ref.accordionDetails,
      accordionSummary = _ref.accordionSummary,
      defaultExpanded = _ref.defaultExpanded,
      width = _ref.width;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    width: width
  });

  var expand = defaultExpanded === 'true';

  var _useState = (0, _react.useState)(expand),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var handleChange = function handleChange() {
    return setExpanded(!expanded);
  };

  var panelSummary = accordionSummary[0];
  var panelDetails = accordionDetails[0];
  return /*#__PURE__*/_react.default.createElement(_core.Accordion, {
    className: styles.root,
    expanded: expanded,
    onChange: handleChange
  }, /*#__PURE__*/_react.default.createElement(_MuiAccordionSummary.default, panelSummary), /*#__PURE__*/_react.default.createElement(_MuiAccordionDetails.default, panelDetails));
};

var _default = MuiAccordion;
exports.default = _default;
MuiAccordion.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** if true pannale is expanded on load */
  defaultExpanded: _propTypes.default.bool,

  /** width of panel */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /** MuiAccordionSummary Allowed maximum: 1 */
  accordionSummary: function accordionSummary(props, propName, componentName) {
    var components = ['MuiAccordionSummary'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  },

  /** MuiAccordionDetails Allowed maximum: 1 */
  accordionDetails: function accordionDetails(props, propName, componentName) {
    var components = ['MuiAccordionDetails'];
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, components, 1);
  }
};
MuiAccordion.defaultProps = {
  width: '100%',
  defaultExpanded: false,
  rootClass: [],
  accordionSummary: [],
  accordionDetails: []
};